import React from 'react';
import { RefreshIcon } from '@heroicons/react/outline';
export default function Spinner({ label = 'Loading' }) {
  return <span role="status" aria-label={label} className="inline-flex items-center gap-2 text-bun-stone"><RefreshIcon className="h-4 w-4 motion-safe:animate-spin" aria-hidden="true" /></span>;
}
